<!--
  @Description cgc 拼团mvp - 倒计时
-->
<template>
<div v-if="show" :class="{ 'group_mvp_process_countdown': true, second: showSecond }">
  <svg xmlns="http://www.w3.org/2000/svg" style="width:1em;height:1em;vertical-align:middle" overflow="hidden" viewBox="0 0 48 48"><defs></defs><g :fill="clockColor"><path d="M24 5.5C13.23 5.5 4.5 14.23 4.5 25S13.23 44.5 24 44.5 43.5 35.77 43.5 25 34.77 5.5 24 5.5zm0 3c9.113 0 16.5 7.387 16.5 16.5S33.113 41.5 24 41.5 7.5 34.113 7.5 25 14.887 8.5 24 8.5z"/><path  d="M10.966 39.058a1.5 1.5 0 0 1 2.174 2.062l-.106.111-3 2.856a1.5 1.5 0 0 1-2.174-2.062l.106-.112 3-2.855zM8.94 3.94a1.5 1.5 0 0 1 2.224 2.007l-.103.114-6 6a1.5 1.5 0 0 1-2.225-2.008l.103-.114 6-6zm30.12 0a1.5 1.5 0 0 0-2.224 2.007l.103.114 6 6a1.5 1.5 0 0 0 2.225-2.008l-.103-.114-6-6zm-2.026 35.118a1.5 1.5 0 0 0-2.174 2.062l.106.111 3 2.856a1.5 1.5 0 0 0 2.174-2.062l-.106-.112-3-2.855zM24 15.5a1.5 1.5 0 0 1 1.493 1.356L25.5 17v7.533l5.275 3.183a1.5 1.5 0 0 1 .578 1.932l-.069.127a1.5 1.5 0 0 1-1.932.578l-.127-.069-6-3.62a1.5 1.5 0 0 1-.717-1.127l-.008-.157V17a1.5 1.5 0 0 1 1.5-1.5z"/></g></svg>
  <div class="time" v-if="showSecond">{{formatSecond}}</div>
  <div class="time" v-if="showDay">{{day}}</div>
</div>
</template>
<script>
import { secondToDate } from '@/common/js/utils.js'
const SHOW_SECOND = 1
const SHOW_DAY = 2
export default {
  props: {
    expireTime: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      formatSecond: '00:00:00',
      interval: null
    }
  },
  mounted () {
    const { second } = this.expireTime
    if (this.showSecond) {
      this.formatSecond = secondToDate(second)
      this.jumpSecond(second)
    }
  },
  watch: {
    'expireTime.second': {
      handler (nVal) {
        if (this.showSecond) {
          this.jumpSecond(nVal)
        }
      }
    }
  },
  computed: {
    showSecond () {
      const { showType } = this.expireTime
      return showType === SHOW_SECOND
    },
    showDay () {
      const { showType } = this.expireTime
      return showType === SHOW_DAY
    },
    show () {
      const { showType, day, dayNum } = this.expireTime
      return !(showType === SHOW_DAY && + dayNum > 7)
    },
    clockColor () {
      return '#FF8040'
    },
    day () {
      const desc = this._('FoodC_Notifications__end_QQPI' /** {{end_time}}天后结束 */)
      const { day } = this.expireTime
      // return desc.replace('{{end_time}}', day.replace('天', ''))
      return day
    }
  },
  methods: {
    jumpSecond (value) {
      // 读秒
      let currentSecond
      this.interval = setInterval(() => {
        currentSecond = value--
        if (currentSecond === 0) {
          clearInterval(this.interval)
        }
        this.formatSecond = secondToDate(currentSecond)
      }, 1000)
    }
  },
  beforeDestroy () {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
}
</script>
<style scoped lang="stylus">
.second svg
  position absolute 
  top 0
  right 128px
.group_mvp_process_countdown
  display flex
  align-items center
  height 32px
  line-height 32px
  font-family 'Aspira Regular'
  font-size 28px
  color #FF8040
  text-align right
  font-weight 400
  .time
    font-size 32px
</style>